import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import mTheme from './theme'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#00BCD4', // Analogo C
        secondary: '#607d8b',
        accent: '#ff5722',
        error: '#f44336',
        warning: '#ff9800',
        info: '#03a9f4',
        success: '#4caf50',

        /** Analogas */
        analogoA: '#0B57E0',
        analogoB: '#0C96EB',
        analogoD: '#0CEBC7',
        analogoE: '#0BE082',

        /** Monocromático */
        monoA: '#004A54',
        monoB: '#42C9DB',
        monoD: '#194D54',
        monoE: '#008EA1',

        /** Tríade */
        triadeA: '#0E7987',
        triadeB: '#D41577',
        triadeD: '#D4BD15',
        triadeE: '#877807',

        /** Complementar */
        compleA: '#007787',
        compleB: '#19E4FF',
        compleC: '#873B00',
        compleD: '#D45C00',

        /** Dividir complementar */
        dCempleA: '#871F0E',
        dCempleB: '#D4270B',
        dCempleD: '#87600E',
        dCempleE: '#D4940B',

        /** Dividir complementar duas vezes */
        dCempleAD: '#0B52D4',
        dCempleBD: '#D43015',
        dCempleDD: '#D49715',
        dCempleED: '#0BD47B',

        /** Quadrado */
        quadradoA: '#15BDD4',
        quadradoB: '#9E15D4',
        quadradoD: '#D46815',
        quadradoE: '#98D40B',

        /** Composto */
        compoA: '#1044A1',
        compoB: '#2C436E',
        compoD: '#D96536',
        compoE: '#A12510',

        /** Sombras */
        sombraA: '#008394',
        sombraB: '#004A54',
        sombraD: '#00C6E0',
        sombraE: '#00A4BA',

        greyPrimary: '#757575',
        greyLight: '#cfcfcf',
        greyDark: '#212121'
      }
    }
  }
})
